import Bowser from 'bowser';
import axios from 'axios';
import { get } from 'lodash';
import { CONTENT_EVENTS } from '@upsolve/shared';

interface IWindowClosedEvent {
  eventType: string;
  deviceId: string;
  eventProperties: {
    browser?: {
      name: string;
      version: string;
    };
    canonicalUrl?: string;
    contentCreationMethod?: string;
    contentGroup?: string;
    contentLocalized?: boolean;
    os?: {
      name: string;
      version: string;
      versionName: string;
    }
    pageComponentName?: string;
    pageComponentVersion?: number;
    path?: string;
    platform?: {
      type: string;
      vendor: string;
    };
    screenHeight?: number;
    screenWidth?: number;
    url?: string;
    wordCount?: number;
  }
}

export default  function trackWindowClosed({
  contentCreationMethod,
  contentGroup,
  contentLocalized,
  pageComponentName,
  pageComponentVersion,
  wordCount,
}: IWindowClosedEvent['eventProperties']) {
  if (pageComponentName == null) throw new Error('Missing Page Component Name');
  if (pageComponentVersion == null) throw new Error('Missing Page Component Version');

  const anonymousId = get(window, 'analytics.user') != null
    ? window.analytics.user().anonymousId()
    : null;

  try {
    const browserProps = Bowser.parse(window.navigator.userAgent);
    const trackBody: IWindowClosedEvent = {
      eventType: CONTENT_EVENTS.WINDOW_CLOSED,
      deviceId: anonymousId,
      eventProperties: {
        browser: browserProps.browser,
        canonicalUrl: get(document.querySelector('link[rel="canonical"]'), 'href'),
        contentCreationMethod,
        contentGroup,
        contentLocalized,
        os: browserProps.os,
        pageComponentName,
        pageComponentVersion,
        path: window.location.pathname,
        platform: browserProps.platform,
        screenHeight: window.innerHeight,
        screenWidth: window.innerWidth,
        url: window.location.href,
        wordCount,
      }
    };
    // var blob= new Blob([JSON.stringify({a:9})], {type : 'application/json; charset=UTF-8'});
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${UPSOLVE_API_URL}/v1/tracking/frontdoor`, false);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
    xhr.send(JSON.stringify(trackBody));
  } catch (error) {
    console.warn(error)
  }
}